import { useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import DataTable from "cxfcomponents/Tables/DataTable";

import DialogWrapper from "layouts/Flow Designer/components/Titlebar/components/DialogWrapper";
import VersionMenu from "layouts/Flow Designer/components/Titlebar/components/FlowVersionsDialog/components/VersionMenu";
import CreateFlowVersionForm from "layouts/Flow Designer/components/Titlebar/components/CreateFlowVersionDialog/components/CreateFlowVersionForm";

import { setFlowVersionsDialogOpen } from "redux/actions/flowDesigner/flowsActionCreator";

import useFlowVersions from "hooks/useFlowVersions";

import { getLocalDateTimeString, formatDateAndTime } from "helpers/common";

const FlowVersionsDialog = () => {
  const { flowVersions } = useFlowVersions();
  const { flowVersionsDialogOpen } = useSelector((state) => state.designer.flows);
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const handleCloseFlowVersionsDialog = () => {
    dispatch(setFlowVersionsDialogOpen(false));
  };

  const dataTableData = useMemo(() => {
    return {
      columns: [
        {
          Header: "version",
          accessor: "version",
          Cell: ({ value }) => (
            <SoftBox sx={{ marginLeft: "34px" }}>
              <SoftTypography fontSize="12px" fontWeight="bold">
                {value}
              </SoftTypography>
            </SoftBox>
          )
        },
        {
          Header: "date created",
          accessor: "created_datetime"
        },
        {
          Header: "actions",
          accessor: "actions"
        }
      ].map((column) => ({ ...column, disableResize: true })),
      rows: flowVersions?.length
        ? flowVersions
            .sort((a, b) =>
              a?.version && b?.version
                ? b.version.localeCompare(a.version, undefined, { numeric: true })
                : 0
            )
            .filter((version) => version?.version)
            .map((version) => {
              return {
                version: version.version,
                created_datetime:
                  formatDateAndTime(getLocalDateTimeString(version.created_datetime)) || "",
                actions: <VersionMenu version={version} />
              };
            })
        : []
    };
  }, [flowVersions]);

  return (
    <DialogWrapper
      open={flowVersionsDialogOpen}
      closeDialog={handleCloseFlowVersionsDialog}
      size="md"
      title="All Versions"
      onSave={() => formRef.current?.submitForm()}
    >
      <SoftBox className="border-top" sx={{ paddingTop: "20px" }}>
        <DataTable table={dataTableData} entriesPerPage={{ defaultValue: 25 }} noTopPart={true} />
      </SoftBox>
      <CreateFlowVersionForm
        formRef={formRef}
        flowVersions={flowVersions}
        handleCloseDialog={handleCloseFlowVersionsDialog}
      />
    </DialogWrapper>
  );
};

export default FlowVersionsDialog;
